export const WHATSAPP_NUMBER = '917996221569';
export const BOOK_URL = 'https://www.omvedha.com/poojaDetails?id=36';
export const SITE_URL = 'https://www.omvedha.com';
export const LOGO_URL = '/images/omvedha-logo.png';
export const BANNER_URL = '/images/omvedha-banner.jpg';
export const SAI_BABA_IMG = '/images/sai-baba-idol.jpg';
export const MAHOTSAVA_DATE = '2026-07-29T06:00:00+05:30';

export const UPI_VPA = 'omvedha1mb@fbl';
export function paymentText(amount) {
  const amt = String(amount || '').replace(/[^\d]/g, '');
  const line = amt ? `Amount: ₹${amt}\n` : '';
  return `\n\nComplete your offering via UPI:\n${line}UPI ID: ${UPI_VPA}`;
}
export const VENUE_NAME = 'Balakrishna Bayalu Ranga Mandira';
export const VENUE_ADDRESS = 'R R Nagar, Bangalore - 560098';
export const VENUE_MAP_EMBED =
  'https://www.google.com/maps?q=Balakrishna+Bayalu+Ranga+Mandira,+RR+Nagar,+Bangalore+560098&output=embed';
export const VENUE_MAP_LINK = 'https://share.google/AS6XvbxNkmkl1gNZC';

export const WHATSAPP_MESSAGE = `Om Sai Ram. I would like to book the following Gurupurnima Sai Baba Mahotsava Seva through Omvedha:
Selected Seva: [Seva Name]
Preferred Date: 29-07-2026
Offering Amount: ₹[Amount]
Please guide me with the next steps and payment process. Thank you.`;

export function whatsappLink() {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
}

export function whatsappSevaLink(seva) {
  const amount = seva.price ? `₹${seva.price}` : (seva.note || 'As per guidance');
  const timing = seva.time ? `\nTiming: ${seva.time}` : '';
  const msg = `Om Sai Ram. I would like to book the following Gurupurnima Sai Baba Mahotsava Seva through Omvedha:\nSelected Seva: ${seva.name}${timing}\nOffering Amount: ${amount}\nPreferred Date: 29-07-2026\nPlease guide me with the next steps.${paymentText(seva.price)}\nThank you.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}

export function whatsappForSelection(items, total) {
  const lines = items.map((s) => `• ${s.displayName || s.name} — ₹${s.amount}`).join('\n');
  const msg = `Om Sai Ram. I would like to sponsor the following sevas for the Gurupurnima Sai Baba Mahotsava (29 July 2026 · Balakrishna Bayalu Ranga Mandira, RajaRajeshwari Nagar, Bangalore):\n\n${lines}\n\nTotal Offering: ₹${total}${paymentText(total)}\n\nPlease guide me with the next steps. Thank you.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}

export const NAV_ITEMS = [
  'Pooja Services',
  'Astrology',
  'Vastu',
  'Numerology',
  'Gemstones',
  'Ritual Essentials',
  'Pooja Essentials',
];

export const BENEFITS = [
  {
    icon: 'HandHeart',
    title: 'Divine Blessings',
    desc: "Receive Sai Baba's grace, protection and abundant blessings.",
  },
  {
    icon: 'Sparkles',
    title: 'Peace & Prosperity',
    desc: 'Invites harmony, financial stability and lasting well-being.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Remove Negativity',
    desc: 'Helps clear obstacles, fear and negative energies from life.',
  },
  {
    icon: 'Users',
    title: 'Family Well-being',
    desc: 'Ensures happiness, good health and unity for your family.',
  },
];

export const POOJA_DETAILS = [
  { icon: 'BookOpen', label: 'Pooja Name', value: 'Gurupurnima Sai Baba Mahotsava' },
  { icon: 'Flower2', label: 'Pooja Type', value: 'Annadana, Abhishekam, Arathi, Sai Baba Moola Mantra Homa' },
  { icon: 'CalendarDays', label: 'Mahotsava Date', value: '29th July 2026' },
  { icon: 'MapPin', label: 'Place / Location', value: 'Bala Krishna Bayalu Ranga Mandira, R R Nagar, Bangalore - 560098' },
];

export const SEVA_SCHEDULE = [
  { icon: 'Sunrise', name: 'Morning Arati', time: '6:30 AM – 7:00 AM', price: '101' },
  { icon: 'Droplets', name: 'Maha Abhishekam', time: '7:00 AM – 9:00 AM', price: '201' },
  { icon: 'Flame', name: 'Chota Arati', time: '8:30 AM – 9:00 AM', price: '101' },
  { icon: 'Sparkles', name: 'Sai Baba Moola Mantra Homa', time: '9:00 AM – 11:00 AM', price: '501' },
  { icon: 'Sun', name: 'Madhyana Arati', time: '12:30 PM – 1:00 PM', price: '101' },
  { icon: 'Wind', name: 'Dhoop Arati', time: '6:00 PM – 6:30 PM', price: '101' },
  { icon: 'Moon', name: 'Shej Arati', time: '8:30 PM – 9:00 PM', price: '101' },
  { icon: 'Utensils', name: 'Anna Dana', time: 'Full Day (6 AM – 9 PM)', price: null, note: 'Optional offering', custom: true, min: 51, defaultAmount: 501 },
];

export const MAHA_SEVA = {
  icon: 'Crown',
  name: 'Maha Seva (All Sevas)',
  displayName: 'Maha Seva (Including Anna Dana)',
  time: 'Full Day',
  desc: 'Includes all sevas above and Anna Dana',
  price: '5001',
};

// Sevas rendered inside the multi-select "Chat on WhatsApp" picker (order matches the mockup).
export const PICKER_SEVAS = [
  ...SEVA_SCHEDULE,
  { icon: 'Crown', name: MAHA_SEVA.name, displayName: MAHA_SEVA.displayName, time: MAHA_SEVA.time, price: MAHA_SEVA.price, bundle: true },
];

export const STEPS = [
  { n: '01', icon: 'CalendarDays', title: 'Choose Date', desc: 'Select your preferred date for the seva.' },
  { n: '02', icon: 'ClipboardList', title: 'Provide Details', desc: 'Fill in your name and gotra.' },
  { n: '03', icon: 'CreditCard', title: 'Secure Payment', desc: 'Safe and easy online payment.' },
  { n: '04', icon: 'BellRing', title: 'Pooja Confirmed', desc: 'We perform the pooja and share updates.' },
];

export const TRUST = [
  { icon: 'BadgeCheck', title: '100% Authentic', sub: 'Rituals' },
  { icon: 'UserCheck', title: 'Experienced &', sub: 'Verified Priests' },
  { icon: 'Flower2', title: 'Pure & Quality', sub: 'Pooja Samagri' },
  { icon: 'Lock', title: 'Secure & Trusted', sub: 'Service' },
];
